/** Вид збереженого подання для поточного подання списку (прототип v4: таблиця й редагування в рядку → таблиця, беклог → дошка, картки → картки). */
import type { SavedViewKind, ViewKey } from '@platform/core/types';

const KIND: Record<string, SavedViewKind> = { table: 'table', inline: 'table', backlog: 'board', cards: 'cards', calendar: 'calendar' };

/** Інші подання — «будь-яке» (any): подання застосовується до всіх подань модуля. Чиста функція. */
export function kindOfView(view: ViewKey): SavedViewKind {
  return KIND[view] ?? 'any';
}
